import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ClientUserGroupInfo } from "../../../../api/types/userManagementTypes";
import type {
  ApprovalConfigurationVersion,
  CreateApprovalConfigurationVersionRequest,
} from "../../../../api/types/workflowTypes";
import type { ObjectTypeToLookupReferences } from "../../../../api/types/objectTypes";
import type { ApprovalConfigurationState, StepValidationResults } from "./approvalConfigurationState";

export interface Props {
  hasEditPermissions: boolean;
  isDraft?: boolean;
  approvalConfiguration: ApprovalConfigurationVersion;
  state: ApprovalConfigurationState;
  setState: React.Dispatch<React.SetStateAction<ApprovalConfigurationState>>;
  editedStepValidationResults?: StepValidationResults;
  clientUserGroups: ClientUserGroupInfo[];
  lookupOptionsByObjectType: Partial<Record<string, ObjectTypeToLookupReferences>>;
  lookupOptionsUnavailable: boolean;
  saveConfiguration: (
    request: CreateApprovalConfigurationVersionRequest,
    successNotification: string
  ) => Promise<boolean>;
}

const ApprovalConfigurationContext = createContext<Props | undefined>(undefined);

export const ApprovalConfigurationContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <ApprovalConfigurationContext value={props}>{children}</ApprovalConfigurationContext>
);

export default ApprovalConfigurationContext;
